import AttendanceItem from './AttendanceItem';

export default AttendanceItem;
